export const CONTENT_UPDATE = 'contentStack/CONTENT_UPDATE';

export const contentUpdate = (data) => ({
  type: CONTENT_UPDATE,
  data
});
